
namespace TabAurous.Reports {
 
    @Serenity.Decorators.registerClass()
    export class OpenConsignmenInGrid extends Serenity.EntityGrid<TabAurous.Purchase.ApprovalInItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.OpenConsignmentInItems'; }
        protected getDialogType() { return TabAurous.Purchase.ApprovalInItemsDialog; }
        protected getIdProperty() { return TabAurous.Purchase.ApprovalInItemsRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Purchase.ApprovalInItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Purchase.ApprovalInItemsRow.localTextPrefix; }
        protected getService() { return TabAurous.Purchase.OpenConsignmentInService.baseUrl; }

        private chartContainer: JQuery;
        private chartPanel: Reports.LineChartPanel;
        constructor(container: JQuery) {
            super(container);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
             
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getSlickOptions(): Slick.GridOptions {
            let opt = super.getSlickOptions();
            opt.rowHeight = 100;
            return opt;
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Purchase/OpenConsignmentIn/PartyList',
                    idField: "LedgerName",
                    textField: "LedgerName",
                    multiple: true
                },
                field: 'PartyId',
                title: 'Vendor',
                handler: w => {
                    var temp = [];
                    if (w.value != null && w.value.length > 0) {
                        var values = w.value;
                        for (var i = 0; i < values.length; i++) {
                            temp.push((values[i]));
                        } if (temp.length != 0) {
                            (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                        }
                    } else
                        (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                },

                cssClass: 'hidden-xs'
            });

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
           


            return filters;
        } 
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            ////grid.registerPlugin(this.autoSize);
            //grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            //this.view.setGrouping([{

            //    getter: 'LedgerName',
            //    displayTotalsRow: false,
            //}])
            return grid;
        }
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            var self = this;
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: TabAurous.Purchase.OpenConsignmentInService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            buttons.push({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    var items = this.view.getItems();
                    if (items.length == 0) {
                        q.alert("Warning", "No data to export", true, 2999);
                        return;
                    }

                    // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    Q.postToService({
                        service: TabAurous.Purchase.OpenConsignmentInService.baseUrl + '/ExportExcelWithOutImages',
                        request: {
                            ProductIds: (self.view.params as ReportFiltersRequest).ProductIds,
                            ProductCodes: (self.view.params as ReportFiltersRequest).ProductCodes,
                            CategoryIds: (self.view.params as ReportFiltersRequest).CategoryIds,
                            SubCategoryIds: (self.view.params as ReportFiltersRequest).SubCategoryIds,
                            LedgerNames: (self.view.params as ReportFiltersRequest).LedgerNames
                        },

                        target: '_blank'
                    });
                }
            });
            buttons.push({
                title: 'Print With Images',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    var items = this.view.getItems();
                    if (items.length == 0) {
                        q.alert("Warning", "No data to export", true, 2999);
                        return;
                    }

                    // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    Q.postToService({
                        service: TabAurous.Purchase.OpenConsignmentInService.baseUrl + '/ExportExcelWithImages',
                        request: {
                            ProductIds: (self.view.params as ReportFiltersRequest).ProductIds,
                            ProductCodes: (self.view.params as ReportFiltersRequest).ProductCodes,
                            CategoryIds: (self.view.params as ReportFiltersRequest).CategoryIds,
                            SubCategoryIds: (self.view.params as ReportFiltersRequest).SubCategoryIds,
                            LedgerNames: (self.view.params as ReportFiltersRequest).LedgerNames
                        },

                        target: '_blank'
                    });
                }
            }); 
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                title: "Print",
                reportTitle: "Open Consignments",
                onViewSubmit: () => this.onViewSubmit()
            }));
            return buttons;
        }
    }
}